// extracted by mini-css-extract-plugin
export var aiStarIcon = "_tr-2";
export var container = "_tr-4";
export var dismissButton = "_tr-3";
export var hasPaddingBottom = "_tr-6";
export var last = "_tr-e";
export var scrollbarThumb = "_tr-c";
export var scrollbarTrack = "_tr-b";
export var selected = "_tr-9";
export var spin = "_tr-1";
export var spinning = "_tr-0";
export var suggestionItem = "_tr-d";
export var suggestionsPanel = "_tr-5";
export var tonePill = "_tr-8";
export var tonesContainer = "_tr-7";
export var unselected = "_tr-a";